<template>
	<section>
		<div class="header">ZIEKTE DOORGEVEN</div>
		<form @submit.prevent="submitUserAvailability">
			<main>
				<div class="line" :class="teamLeaderChecked ? 'checked' : ''">
					<span class="question">Heb je de teamleider gebeld voor 06:00 uur?</span>
					<ToggleField :checked="teamLeaderChecked" @change="teamLeaderChecked = !teamLeaderChecked; officeChecked = false"></ToggleField>
				</div>
				<div class="line" v-if="teamLeaderChecked === false">
					<span>{{ teamLeader.display_name }}</span>
					<a :href="`tel:${teamLeader.phone}`" class="icon"><PhoneIcon></PhoneIcon></a>
				</div>
				<div class="line" :class="officeChecked ? 'checked' : ''" v-if="teamLeaderChecked">
					<span class="question">Vergeet niet om ook naar kantoor te bellen tussen 08:30 en 09:00.</span>
					<ToggleField :checked="officeChecked" @change="officeChecked = !officeChecked"></ToggleField>
				</div>
				<div class="line" v-if="teamLeaderChecked && !officeChecked" v-for="employee in officeEmployees">
					<span>{{ employee.display_name }}</span>
					<a :href="`tel:${employee.phone}`" class="icon"><PhoneIcon></PhoneIcon></a>
				</div>
			</main>
			<div class="actions">
				<Button class="Button cancel" @click="$router.back()">ANNULEER</Button>
				<Button v-if="officeChecked" type="submit" class="Button submit">MELDEN</Button>
			</div>
		</form>
	</section>
</template>

<script>
import Button from "../Button.vue";
import ToggleField from "../ToggleField.vue";
import { PhoneIcon } from 'vue-feather-icons';
import { client } from "../../store";
import {mapActions} from "vuex";

export default {
	name: "SubmitAvailabilityZiekte",
	components: {Button, ToggleField, PhoneIcon},

	props: {
		teamLeader: null,
		officeEmployees: null
	},

	data() {
		return {
			teamLeaderChecked: false,
			officeChecked: false
		}
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		submitUserAvailability() {
			this.setLoading();

			client.query(`
				mutation($type: String) {
					createUserAvailability(type: $type)
				}
			`, {
				type: "ziekte"
			}).then(() => {
				this.setIdle();
				this.$notify({
					group: "app",
					title: "Ziekte doorgegeven",
					type: "success",
					text: "Ziekte is succesvol doorgegeven"
				});

				this.$router.push({name: 'home'});
			}).catch((error) => {
				this.setIdle();
				if (error.hasOwnProperty("rawError") && error.rawError.length > 0 && error.rawError[0].debugMessage === "user_availability already exists") {
					this.$notify({
						group: "app",
						title: "Ziekte doorgeven mislukt",
						type: "error",
						text: "Je hebt vandaag al ziekte doorgegeven"
					});
				} else {
					this.$notify({
						group: "app",
						title: "Ziekte doorgeven mislukt",
						type: "error",
						text: "Er is iets misgegaan bij het doorgeven van ziekte"
					});
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
	main {
		border-bottom: 2px solid #eee;
	}

	.header {
		width: 100%;
		background-color: #1aae9f;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
		padding: 8px;
	}

	.line {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 12px 16px;

		span {
			align-self: center;

			&.question {
				font-weight: bold;
			}
		}

		a {
			padding: 8px 8px 4px 8px;
			background-color: #2c88d9;
			border-radius: 4px;
			color: #FFF;
		}
	}

	.checked.line {
		background-color: #e3e8ed;
	}

	.actions {
		display: flex;
		justify-content: space-between;

		Button {
			font-weight: bold;
			color: #FFFFFF;
			border-radius: 4px;
			margin: 16px;

			&.cancel {
				background-color: #d3455b;
			}
			&.submit {
				background-color: #1aae9f;
			}
		}
	}
</style>
